import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import React from 'react'
import styled from 'styled-components'

const ModalSubTitle = styled.h2`
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 24px;
	text-align: center;
	letter-spacing: 0.15px;
	padding: 20px;
`

const CenteredDialogTitle = styled(DialogTitle)`
	text-align: center;
	padding-bottom: 0px;
`

const CenteredDialogContentText = styled(DialogContentText)`
	text-align: center;
`

const CenteredDialogAction = styled(DialogActions)`
	justify-content: center;
	padding-bottom: 20px;
`

// Generic Dialogs
export const ErrorDialog = ({ open, onClose, message }) => {
  return (
    <Dialog onClose={onClose} open={open}>
      <CenteredDialogTitle>Failed</CenteredDialogTitle>
      <ModalSubTitle aria-label="error-message" role="error-dialog">
        {message}
      </ModalSubTitle>
      <CenteredDialogAction>
        <Button color="primary" onClick={() => onClose()}>
					Close
        </Button>
      </CenteredDialogAction>
    </Dialog>
  )
}

export const SuccessDialog = ({ open, onClose, message }) => {
  return (
    <Dialog fullWidth={true} maxWidth={'sm'} onClose={onClose} open={open}>
      <CenteredDialogTitle>Success!</CenteredDialogTitle>
      <CenteredDialogContentText
        aria-label="success-message"
        role="success-dialog"
      >
        {message}
      </CenteredDialogContentText>
      <CenteredDialogAction>
        <Button color="primary" onClick={() => onClose()}>
					Close
        </Button>
      </CenteredDialogAction>
    </Dialog>
  )
}

export const ActionDialogFooter = ({ onClose, action, actionName }) => {
  return (
    <CenteredDialogAction>
      <Button onClick={() => onClose()}>Cancel</Button>
      <Button
        aria-label={actionName}
        color="primary"
        onClick={action}
        type="submit"
        variant="contained"
      >
        {actionName}
      </Button>
    </CenteredDialogAction>
  )
}

// Specific Dialogs
export const MergeDialog = ({ open, onClose, merge }) => {
  return (
    <Dialog onClose={onClose} open={open}>
      <CenteredDialogTitle>
				Are you sure you&apos;d like to merge accounts?
      </CenteredDialogTitle>
      <ModalSubTitle>This action cannot be undone.</ModalSubTitle>
      <DialogContent>
        <CenteredDialogContentText>
					Only <b>applications</b> from the account(s) chosen to be merged will
					be moved to the account selected as Primary.
        </CenteredDialogContentText>
      </DialogContent>
      <ActionDialogFooter
        action={merge}
        actionName="MERGE ACCOUNTS"
        onClose={onClose}
      />
    </Dialog>
  )
}

export const HideDialog = ({ open, onClose, hide }) => {
  return (
    <Dialog onClose={onClose} open={open}>
      <CenteredDialogTitle>
				Are you sure you&apos;d like to hide these fields?
      </CenteredDialogTitle>
      <ActionDialogFooter action={hide} actionName="HIDE" onClose={onClose} />
    </Dialog>
  )
}

export const PowerExtensionDialog = ({ addRemove, onClose, open, portal }) => {
  return (
    <Dialog onClose={onClose} open={open}>
      <CenteredDialogTitle>
				Are you sure you&apos;d like to make these changes to portal code c_
        {portal}?
      </CenteredDialogTitle>
      <ActionDialogFooter
        action={addRemove}
        actionName="ADD/REMOVE LOCATIONS"
        onClose={onClose}
      />
    </Dialog>
  )
}

export const SyncDialog = ({ open, onClose, sync }) => {
  return (
    <Dialog onClose={onClose} open={open}>
      <CenteredDialogTitle>
				Are you sure you&apos;d like to sync this applicant?
      </CenteredDialogTitle>
      <ActionDialogFooter action={sync} actionName="SYNC" onClose={onClose} />
    </Dialog>
  )
}
